import React from "react";
import { motion } from "framer-motion";

const stats = [
  { num: "45", unit: "ha", label: "backlot at Victoria Flats" },
  { num: "500", unit: "m²", label: "built wet-weather cover" },
  { num: "10,000", unit: "ha+", label: "of freehold NZ station land" },
  { num: "90", unit: "km", label: "All freehold land & shoot locations within range of the film hub" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#E2B464]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
                01 — The Studio
              </span>
            </div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
              Est. Victoria Flats / NZ
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="md:col-span-8"
          >
            <h2 className="font-display font-light text-white text-4xl md:text-6xl leading-[1] tracking-tighter">
              Named after the iconic{" "}
              <span className="italic text-[#E2B464]">Arcadia Station</span> at
              Paradise. We are long-term New Zealand freehold land owners of
              stations spanning over 10,000 hectares, home to many of the
              country's most regarded international shoots.
            </h2>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="border-l border-white/10 pl-5"
                >
                  <div className="flex items-baseline gap-1">
                    <span className="font-display text-4xl md:text-5xl font-extralight text-white tracking-tight">
                      {s.num}
                    </span>
                    <span className="font-mono text-xs text-zinc-500">{s.unit}</span>
                  </div>
                  <p className="mt-2 text-xs text-zinc-400 leading-relaxed">{s.label}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
